// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2728":"3a2eca24","2945":"dd1a35db"}[chunkId] + ".chunk.css";
};